let endDate           // 投保结束日期
let serviceLink       // 小程序首页链接
let appId             // 小程序ID
let endDateReset      // 重置投保结束日期
let officialLink      // 官方地址投保地址

if (process.env.NODE_ENV === 'production') { // 生产环境
	endDate = '2026-1-27'
	endDateReset = '2026-1-31'
	serviceLink = 'http://uphb.joinusibc.com/#/'
	appId = 'fbbb35978ac3539d'
  // officialLink = 'https://hmbcloud.webao99.com/bj26/front-insured/?flag=OUT&channelType=PRIVATE&orderChannel=H5&projectid=124293784147386368&promotionId=AGENT_LEADER_30696154896670721&skuNo=BXHM0023#/home/26750637492117504' // 官方地址
  officialLink = 'https://hmbcloud.webao99.com/bj26/front-insured/?flag=OUT&channelType=PRIVATE&orderChannel=YSF&projectid=124293784147386368&promotionId=AGENT_LEADER_30696154896670721&skuNo=BXHM0023#/home/26750637492117504'
} else { // development or test | 开发环境 or 测试环境
	endDate = '2026-1-27'
	endDateReset = '2026-1-31'
	serviceLink = 'http://huiminbao.youbaolian.top/#/'
	appId = 'b364a3006a6e186f'
  // officialLink = 'https://hmbcloud.webao99.com/front-insured-bjt/?flag=OUT&channelType=PRIVATE&orderChannel=H5&projectid=123745856899457024&promotionId=AGENT_LEADER_26984502679412737&skuNo=BXHM0305#/home/25859306139254784' // 官方地址
  // officialLink = 'https://hmbcloud.webao99.com/front-insured-bjt/?flag=OUT&channelType=PRIVATE&orderChannel=H5&projectid=123745856899457024&promotionId=AGENT_LEADER_27491056491102209&skuNo=BXHM0305#/home/25859306139254784'
  // officialLink = 'https://hmbcloud.webao99.com/front-insured-bjt/?flag=OUT&channelType=PRIVATE&orderChannel=YSF&projectid=123745856899457024&promotionId=AGENT_LEADER_27491056491102209&skuNo=BXHM0305#/home/25859306139254784'
  // officialLink = 'https://hmbcloud.webao99.com/insuredJrzw-prevbj/?flag=OUT&channelType=PRIVATE&orderChannel=YSF&projectid=123745856899457024&promotionId=AGENT_LEADER_27491056491102209&skuNo=BXHM0305#/home/25859306139254784'
  officialLink = 'https://hmbcloud.webao99.com/insuredJrzw-prevbj/?flag=OUT&channelType=PRIVATE&orderChannel=YSF&projectid=123745856899457024&promotionId=AGENT_LEADER_27956915487776769&skuNo=BXHM0305#/home/25859306139254784'
}

export default {
	endDate, serviceLink, appId, endDateReset, officialLink
}